<template>
  <div class="ProjectMasthead">
    <div class="banner" :style="'background:' + bgColour">
      <div class="wrapper">
        <h1>{{ title }}</h1>
        <h2>{{ subtitle }}</h2>
      </div>
    </div>
    <div class="preview">
      <img :src="srcImage" :srcset="srcSet" sizes="(max-width: 900px) 100vw, 855px">
    </div>
  </div>
</template>

<script>

export default {
  name: 'ProjectMasthead',
  props: {
    srcImage: {
      type: String,
      default: null
    },
    largeImage: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
    bgColour: {
      type: String,
      default: null
    }
  },
  data() {
    return {
    }
  },
  methods: {
  },
  computed: {
    srcSet() {
      return this.srcImage + ' 855w, ' + this.largeImage + ' 1710w'
    }
  }
}
</script>

<style lang="scss" scoped>
.ProjectMasthead {
  position: relative;
  
  & .banner {
    padding: 160px 0 19% 0;
    // padding: 160px 0 180px 0;

    & .wrapper {
      @include siteWrapper;
      text-align: center;

      & h1 {
        margin: 0 0 60px 0;
      }
    }
  }
  & .preview {
    width: 100%;
    margin: -15vw auto 0 auto;
    animation: loadContent 500ms 600ms forwards;
    opacity: 0;

    @keyframes loadContent {
      from {opacity: 0;}
      to {opacity: 1;}
    }

    & img {
      display: block;
      width: 855px;
      height: auto;
      margin: 0 auto;
    }
  }

  @media screen and (max-width: $breakWide) {
    & .banner {
      padding: 160px 0 23% 0;

      & .wrapper {
        & h1 {
          margin: 0 0 50px 0;
        }
      }
    }
    & .preview {
      margin: -19vw auto 0 auto;
    }
  }
  @media screen and (max-width: 1100px) {
    & .banner {
      padding: 160px 0 28% 0;
    }
    & .preview {
      margin: -22vw auto 0 auto;
    }
  }
  @media screen and (max-width: 865px) {
    & .banner {
      padding: 160px 0 30% 0;
    }
    & .preview {
      width: calc(100% - 40px);
      margin: -24vw auto 0 auto;

      & img {
        display: block;
        width: 100%;
        height: auto;
        margin: 0 auto;
      }
    }
  }
  @media screen and (max-width: $breakSmall) {
    & .banner {
      padding: 120px 0 30% 0;

      & .wrapper {
        & h1 {
          margin: 0 0 40px 0;
        }
      }
    }
    & .preview {
      margin: -26vw auto 0 auto;
    }
  }
}
</style>
